import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';

import { countries } from '../../shared/Mappings';

const styles = theme => ({
  grid: {
    padding: theme.spacing(5),
  },
});

function AddressForm(props) {
  const {
    classes,
    addresses,
    activeAddress,
    changeAddress,
    onChange,
    addressFName,
    addressLName,
    addressLine1,
    addressLine2,
    addressCity,
    addressState,
    addressZip,
    addressCountry,
    addressErrors,
    addressErrorStates,
    handleSaveAddressChange,
    addressHasChanged,
    saveAddress,
  } = props;
  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Shipping address
      </Typography>
      <Grid container className={classes.grid} spacing={3}>
        { addresses.length > 0 && (
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined">
              <InputLabel color="secondary">Addresses</InputLabel>
              <Select
                placeholder="Select Address"
                value={activeAddress}
                className=""
                onChange={e => changeAddress(e)}
                width={85}
                input={(
                  <OutlinedInput
                    labelWidth={85}
                  />
                )}
              >
                <MenuItem key="newaddress" value={0}>New Address&nbsp;&nbsp;</MenuItem>
                {addresses.map((address, i) => (
                  <MenuItem key={address.id} value={i + 1}>{address.line1}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="firstName"
            name="addressFName"
            label="First name"
            fullWidth
            autoComplete="fname"
            value={addressFName}
            onChange={e => onChange(e)}
            error={addressErrorStates.addressFName}
            helperText={addressErrors.addressFName}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="lastName"
            name="addressLName"
            label="Last name"
            fullWidth
            autoComplete="lname"
            value={addressLName}
            onChange={e => onChange(e)}
            error={addressErrorStates.addressLName}
            helperText={addressErrors.addressLName}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            id="address1"
            name="addressLine1"
            label="Address line 1"
            fullWidth
            autoComplete="billing address-line1"
            value={addressLine1}
            onChange={e => onChange(e)}
            error={addressErrorStates.addressLine1}
            helperText={addressErrors.addressLine1}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="address2"
            name="addressLine2"
            label="Address line 2"
            fullWidth
            autoComplete="billing address-line2"
            value={addressLine2}
            onChange={e => onChange(e)}
            error={addressErrorStates.addressLine2}
            helperText={addressErrors.addressLine2}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="city"
            name="addressCity"
            label="City"
            fullWidth
            autoComplete="billing address-level2"
            value={addressCity}
            onChange={e => onChange(e)}
            error={addressErrorStates.addressCity}
            helperText={addressErrors.addressCity}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="state"
            name="addressState"
            label="State/Province/Region"
            fullWidth
            value={addressState}
            onChange={e => onChange(e)}
            error={addressErrorStates.addressState}
            helperText={addressErrors.addressState}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="zip"
            name="addressZip"
            label="Zip / Postal code"
            fullWidth
            autoComplete="billing postal-code"
            value={addressZip}
            onChange={e => onChange(e)}
            error={addressErrorStates.addressZip}
            helperText={addressErrors.addressZip}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            select
            required
            fullWidth
            id="country"
            name="addressCountry"
            label="Country"
            autoComplete="billing country"
            value={addressCountry}
            onChange={e => onChange(e)}
            error={addressErrorStates.addressCountry}
            helperText={addressErrors.addressCountry}
          >
            {countries.map(country => (
              <MenuItem key={country.code} value={country.code}>{country.name}</MenuItem>
            ))}
          </TextField>
        </Grid>
        {addressHasChanged && (
          <Grid item xs={12}>
            <FormControlLabel
              control={<Checkbox color="secondary" name="saveAddress" checked={saveAddress} value="yes" />}
              label="Save this address for future use"
              onChange={e => handleSaveAddressChange(e)}
            />
          </Grid>
        )}
      </Grid>
    </React.Fragment>
  );
}

AddressForm.propTypes = {
  classes: PropTypes.object.isRequired,
  addresses: PropTypes.array.isRequired,
  activeAddress: PropTypes.number.isRequired,
  changeAddress: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  addressFName: PropTypes.string.isRequired,
  addressLName: PropTypes.string.isRequired,
  addressLine1: PropTypes.string.isRequired,
  addressLine2: PropTypes.string.isRequired,
  addressCity: PropTypes.string.isRequired,
  addressState: PropTypes.string.isRequired,
  addressZip: PropTypes.string.isRequired,
  addressCountry: PropTypes.string.isRequired,
  addressErrors: PropTypes.object.isRequired,
  addressErrorStates: PropTypes.object.isRequired,
  handleSaveAddressChange: PropTypes.func.isRequired,
  addressHasChanged: PropTypes.bool.isRequired,
  saveAddress: PropTypes.bool.isRequired,
};

export default withStyles(styles)(AddressForm);
